import get from 'lodash/get';
import { canUseDOM } from 'exenv';
import URL from 'url-parse';
import * as postActions from '../../action_creators/post/post_action_creators';
import PostModel from '../../../models/post/post';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import redirectPostActionCreator from '../../action_creators/redirect_action_creators';

import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    const state = store.getState();
    dispatch(postActions.postLoading({}, store));
    return PostModel.fetch(params, store)
      .then(function handlePostDetailData(PostData) {
        const isPreview = get(state, 'config.isPreview');
        const isAmp = get(state, 'config.amp');
        let postLink = get(PostData, 'data.post.link');
        const currentUrl = get(state, 'config.navHistory[0]');
        if (!canUseDOM && postLink && !isPreview) {
          if (currentUrl !== postLink) {
            const parsedCurrent = new URL(currentUrl).pathname;
            const parsedPostLink = new URL(postLink).pathname;
            if (parsedCurrent !== parsedPostLink) {
              if (isAmp) {
                postLink = postLink.replace('www', 'amp');
              }
              dispatch(
                redirectPostActionCreator({
                  status: 301,
                  redirect: postLink
                })
              );
            }
          }
        }

        dispatch(postActions.postLoaded(PostData.data, store));
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 400 || status === 403) {
          dispatch(notFoundActionCreator(403, 'UNPUBLISHED_STATUS', store));
        }
        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }
        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }
        dispatch(postActions.postLoadError(err, store));
        log.error(err, `Error in post actions, message: ${err.message}`);
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/post/async_post_actions.js